// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LeftSquareFilledSvg from "@fishx/icons-svg/es/asn/LeftSquareFilled";
import FishxIcon from '../components/FishxIcon';

var LeftSquareFilled = function LeftSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LeftSquareFilledSvg
  }));
};

LeftSquareFilled.displayName = 'LeftSquareFilled';
export default React.forwardRef(LeftSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LeftSquareFilled.js
// module id = 3023
// module chunks = 0